<template>
  <v-container
    tag="section"
  >
    <v-form ref="form">
      <v-col
        cols="12"
        class="px-0"
      >
        <v-row
          align="stretch"
          justify="start"
        >
          <v-col
            cols="12"
          >
            <base-material-card
              color="coolrunner"
              icon="mdi-map-marker-path"
              :avatar="entity.picture || null"
              inline
              class="px-5 py-3"
            >
              <template
                v-slot:after-heading
              >
                <div>
                  <v-text-field
                    v-model="entity.title"
                    :rules="rules"
                    class="text-h2 font-weight-light"
                    :label="$t('title')"
                  />
                </div>
              </template>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <GmapMap
                      ref="map"
                      style="width: 100%; height: 400px;"
                      :zoom="1"
                      :center="{lat: 0, lng: 0}"
                      :options="{
                        disableDefaultUI: true
                      }"
                    />
                    <v-row class="mt-4 ml-1">
                      <v-btn
                        color="primary"
                        :disabled="!enableGenerateRoute"
                        class="mt-3"
                        @click="generateRoute"
                      >
                        {{ $t('generate_route') }}
                      </v-btn>
                      <v-col>
                        <v-text-field
                          :label="$t('distance')"
                          :value="formattedDistance"
                          readonly
                          suffix="km"
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          :label="$t('duration_google')"
                          :value="formattedDurationGoogle"
                          readonly
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          :label="$t('duration_average')"
                          :value="formattedDurationAverage"
                          readonly
                        />
                      </v-col>
                    </v-row>
                    <v-textarea
                      v-model="entity.comment"
                      :label="$t('comment')"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="entity.average_speed"
                          type="number"
                          :label="$t('average_speed')"
                          suffix="km/h"
                        />
                      </v-col>
                      <v-col cols="10">
                        <v-autocomplete
                          v-model="selectedAddress"
                          :search-input.sync="query"
                          :items="addresses"
                          :loading="fetchingAddresses"
                          :hide-no-data="!search.length || fetchingAddresses"
                          label="Find stop"
                          item-text="address_formatted"
                          return-object
                          :filter="() => true"
                          @update:search-input="search"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-menu
                          ref="menu_from"
                          v-model="menuStart"
                          :close-on-content-click="false"
                          :return-value.sync="entity.start_time"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="entity.start_time"
                              :label="$t('start_time')"
                              prepend-icon="event"
                              readonly
                              dense
                              v-on="on"
                            />
                          </template>
                          <v-time-picker
                            v-model="entity.start_time"
                            format="24hr"
                          >
                            <v-spacer />
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_from.save(entity.start_time)"
                            >
                              {{ $t('ok') }}
                            </v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-card
                      v-if="entity.waypoints && entity.waypoints.length"
                      class="mx-auto"
                      tile
                    >
                      <v-list>
                        <draggable
                          :list="entity.waypoints"
                          @start="drag=true"
                          @end="drag=false"
                        >
                          <v-list-item
                            v-for="(element, index) in entity.waypoints"
                            :key="element.id"
                            style="cursor: grab;"
                            class="d-flex flex-column"
                          >
                            <v-col>
                              <v-row justify="space-between">
                                <v-avatar
                                  color="red"
                                  size="36"
                                >
                                  <span class="white--text text-h5">{{ alphabet[index].toUpperCase() }}</span>
                                </v-avatar>

                                <v-icon
                                  medium
                                  color="red"

                                  icon="mdi-delete"
                                  @click="removeWaypoint(index)"
                                >
                                  mdi-delete
                                </v-icon>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  v-model="element.name"
                                  :placeholder="$t('enter_name')"
                                />
                              </v-row>
                              <v-row>
                                {{ element.address_string }}
                              </v-row>
                              <v-row>
                                {{ $t('arrival') }} (Google): {{ arrivalTimesGoogle[index] }}
                              </v-row>
                              <v-row>
                                {{ $t('arrival') }} ({{ $t('average_speed') }}): {{ arrivalTimesAverage[index] }}
                              </v-row>
                            </v-col>
                            <v-text-field
                              v-model="element.pause"
                              class="mt-5"
                              style="width: 100%"
                              dense
                              type="number"
                              min="0"
                              suffix="min"
                              :label="$t('pause_in_minutes')"
                            >
                              <v-divider style="width: 100%" />
                            </v-text-field>
                          </v-list-item>
                        </draggable>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-row>
                      <v-btn
                        color="green"
                        bottom
                        right
                        class="ml-auto"
                        @click="validate()"
                      >
                        <v-icon class="mr-3">
                          mdi-content-save
                        </v-icon>
                        {{ $t('save') }}
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </base-material-card>
          </v-col>
          <base-loading-overlay :loading="loading" />
        </v-row>
      </v-col>
    </v-form>
  </v-container>
</template>
<script>
  import Edit from '@/mixins/Edit'
  import { SUPERUSER } from '../../../utils/constants'

  export default {
    mixins: [Edit],
    data () {
      return {
        endpoint: 'linehaul-routes',
        name: 'linehaul_route',
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPERUSER.val,
        },
        query: '',
        addresses: [],
        selectedAddress: {},
        directionsDisplay: null,
        alphabet: [...'abcdefghijklmnopqrstuvwxyz'],
        timerId: null,
        fetchingAddresses: false,
        menuStart: false,
        entity: {
          name: '',
          address_string: '',
          comment: '',
          distance: 0,
          duration: 0,
          google_duration: 0,
          average_speed: 80,
          start_time: '12:00',
          waypoints: [],
        },
        fetchSuccess: this.generateRoute,
      }
    },
    computed: {
      averageSpeedinMS: function () {
        return (parseInt(this.entity.average_speed) * 5) / 18
      },
      trimmedWaypoints: function () {
        const ewp = this.entity?.waypoints || []

        const wps = [...ewp]
        wps.shift()
        wps.pop()

        return this.$_.map(wps, wp => ({
          location: { lat: wp.latitude, lng: wp.longitude },
          stopover: true,
        }))
      },
      enableGenerateRoute: function () {
        const ewp = this.entity?.waypoints || []

        return ewp.length >= 2
      },
      totalPause: function () {
        const ewp = this.entity?.waypoints || []

        return this.$_.sumBy(this.entity.waypoints, wp => parseInt(wp.pause || 0))
      },
      formattedDistance: function () {
        return (this.entity.distance / 1000).toFixed(2)
      },
      formattedDurationGoogle: function () {
        var num = (this.entity.google_duration / 60) + this.totalPause
        var hours = (num / 60)
        var rhours = Math.floor(hours)
        var minutes = (hours - rhours) * 60
        var rminutes = Math.round(minutes)
        return `${(`${rhours}`).padStart(2, '0')}:${(`${rminutes}`).padStart(2, '0')}`
      },
      formattedDurationAverage: function () {
        const hours = (this.entity.distance / 1000) / parseInt(this.entity.average_speed) + (this.totalPause / 60)

        var rhours = Math.floor(hours)
        var minutes = (hours - rhours) * 60
        var rminutes = Math.round(minutes)
        return `${(`${rhours}`).padStart(2, '0')}:${(`${rminutes}`).padStart(2, '0')}`
      },
      arrivalTimesGoogle: function () {
        const times = [
          this.entity.start_time,
        ]
        if (this.entity) {
          this.$_.each(this.entity.legs, (leg, index) => {
            times.push(this.$moment(times[index], 'HH:mm').add(this.entity.waypoints[index]?.pause || 0, 'm').add(leg.duration.value, 's').format('HH:mm'))
          })
        }
        return times
      },
      arrivalTimesAverage: function () {
        const times = [
          this.entity.start_time,
        ]

        if (this.entity) {
          this.$_.each(this.entity.legs, (leg, index) => {
            times.push(this.$moment(times[index], 'HH:mm').add(this.entity.waypoints[index]?.pause || 0, 'm').add(leg.distance.value / this.averageSpeedinMS, 's').format('HH:mm'))
          })
        }
        return times
      },
    },
    watch: {
      selectedAddress: function (newVal) {
        if (newVal) { this.addWaypoint(newVal) }
      },
    },

    methods: {
      addWaypoint: function (waypoint) {
        if (!waypoint.address_formatted) { return }
        const exists = this.$_.findIndex(this.entity.waypoints, wp => { return wp.latitude === waypoint.latitude && wp.longitude === waypoint.longitude })
        if (exists > -1) {
          this.$toast(this.$t('already_added'))
          return
        }
        this.entity.waypoints.push(
          {
            address_string: waypoint.address_formatted,
            latitude: waypoint.latitude,
            longitude: waypoint.longitude,
            stopover: true,
            pause: 0,
          },
        )
        this.selectedAddress = {}
      },
      removeWaypoint: function (index) {
        const wps = [...this.entity.waypoints]

        wps.splice(index, 1)
        this.entity.waypoints = wps
      },
      search: function () {
        if (!this.query) { return }

        this.findAddress()
      },
      findAddress: function () {
        clearTimeout(this.timerId)
        this.fetchingAddresses = true

        this.timerId = setTimeout(() => {
          this.$get(`/geolocation/geo?all=true&country_code=DK&query=${this.query}`)
            .then(({ data }) => {
              this.fetchingAddresses = false
              const addresses = data.response_data
              this.addresses = this.$_.uniqWith(addresses, (a, b) => {
                return (a.latitude === b.latitude && a.longitude === b.longitude)
              })
            })
            .catch(e => {
              this.fetchingAddresses = false
            })
        }, 500)
      },
      generateRoute: function () {
        const directionsService = new google.maps.DirectionsService()
        if (!this.directionsDisplay) { this.directionsDisplay = new google.maps.DirectionsRenderer() }

        const request = {
          origin: { lat: this.entity.waypoints[this.entity.waypoints.length - 1].latitude, lng: this.entity.waypoints[this.entity.waypoints.length - 1].longitude },
          waypoints: this.trimmedWaypoints,
          destination: { lat: this.entity.waypoints[this.entity.waypoints.length - 1].latitude, lng: this.entity.waypoints[this.entity.waypoints.length - 1].longitude },
          travelMode: 'DRIVING',
        }

        if (this.enableGenerateRoute) {
          directionsService.route(request, (response, status) => {
            this.directionsDisplay.setMap(null)
            this.entity.distance = 0
            this.entity.google_duration = 0

            this.$nextTick(() => {
              this.$refs.map.$mapPromise.then(map => {
                this.directionsDisplay.setMap(map)
              })
            })

            if (status === 'OK') {
              this.directionsDisplay.setDirections(response)
              const legs = this.$_.map(response.routes[0].legs, leg => ({ distance: leg.distance, duration: leg.duration }))
              const route = { legs, distance: null, google_duration: null }
              this.$_.each(route.legs, leg => {
                route.distance += leg.distance.value
                route.google_duration += leg.duration.value
              })
              this.entity = { ...this.entity, ...route }
            } else {
              window.alert(`Directions request failed due to ${status}`)
            }
          })
        }
      },
      save: function () {
        if (!this.entity.id && !this.canCreate()) { return }
        if (this.entity.id && !this.canUpdate()) { return }

        this.loading = true

        const hours = (this.entity.distance / 1000) / parseInt(this.entity.average_speed) + (this.totalPause / 60)

        var rhours = Math.floor(hours)
        var minutes = (hours - rhours) * 60
        const duration = Math.round(minutes * 60)

        const { legs, ...trimmedEntity } = this.entity
        const entity = { ...trimmedEntity, duration }

        const method = this.entity.id ? this.$put : this.$post
        method(`/${this.endpoint}${this.entity.id ? `/${this.entity.id}` : ''}`, entity)
          .then(response => {
            this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)
            if (this.entity.id) { this.entity = response.data } else { this.$router.replace({ name: this.$route.name, params: { id: response.data.id } }) }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
    },
  }
</script>
